/*
  AoA · Filtro «Weight» de la colección (Bryan, 2026-10-15). Solo tema: sin Search & Discovery, nada que main vea.
  - El gramaje de cada producto sale de templates/collection.aoa-weights.liquid (?view=aoa-weights con los filtros de
    Shopify de la URL), que lo lee del título (110/160/300/420).
  - La selección vive en la URL como weight=160,300 (input oculto del cajón, snippets/aoa-facets-weight.liquid), así
    sobrevive a cada filtro, al orden, a la carga infinita y a compartir el enlace. Shopify ignora ese parámetro.
  - Con gramaje elegido: las tarjetas que no coinciden se ocultan (.aoa-weight-out), los conteos («N products»,
    «View N products», «Showing X of N») pasan a contar solo las que coinciden y la carga infinita sigue pidiendo
    páginas hasta traerlas todas (assets/aoa-collection.js). Cajas sin productos con los otros filtros: deshabilitadas.
  - Chip activo por gramaje en la barra de filtros; los chips del servidor no conocen weight y se les añade.
*/
(function () {
  'use strict';
  if (window.aoaWeight) return;
  var cache = {};

  function selected() {
    var v = new URLSearchParams(location.search).get('weight') || '';
    return v.split(',').filter(function (x) { return /^(110|160|300|420)$/.test(x); });
  }
  function serverParams() {
    var p = new URLSearchParams(location.search);
    p.delete('weight'); p.delete('page'); p.delete('section_id'); p.delete('view');
    return p;
  }
  function load() {
    var p = serverParams(), key = p.toString();
    if (cache[key]) return cache[key];
    var base = location.pathname + '?view=aoa-weights' + (key ? '&' + key : '');
    cache[key] = fetch(base + '&page=1').then(function (r) { return r.text(); }).then(function (t) {
      var first = JSON.parse(t), items = first.items, rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(fetch(base + '&page=' + n).then(function (r) { return r.text(); }).then(function (x) { return JSON.parse(x).items; }));
      return Promise.all(rest).then(function (more) { more.forEach(function (m) { items = items.concat(m); }); return items; });
    }).catch(function () { delete cache[key]; return null; });
    return cache[key];
  }
  function hiddenSet() {
    var g = document.querySelector('[data-aoa-weight]');
    return ((g && g.getAttribute('data-hidden')) || '').split(',').filter(Boolean);
  }
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]'); if (!a) return '';
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : '';
  }
  function setCountText(n) {
    document.querySelectorAll('.thb-filter-count .facets__label, #ProductCount .facets__label').forEach(function (el) {
      if (!el.dataset.aoaOriginal) el.dataset.aoaOriginal = el.textContent;
      el.textContent = n === null ? el.dataset.aoaOriginal : el.dataset.aoaOriginal.replace(/\d[\d,]*/, String(n));
    });
    var btn = document.querySelector('[data-aoa-apply]');
    if (btn) {
      var src = document.querySelector('.mobile-filter-count .facets__label');
      var m = src && src.textContent.match(/\d[\d,]*/);
      if (m) (btn.querySelector('span') || btn).textContent = (btn.dataset.text || 'View [count] products').replace('[count]', m[0]);
    }
  }

  var state = { sel: [], map: null, count: null };
  window.aoaWeight = state;

  function syncDrawer() {
    var g = document.querySelector('[data-aoa-weight]'); if (!g) return;
    var sel = state.sel, input = g.querySelector('[data-aoa-weight-input]');
    if (input) { input.value = sel.join(','); input.disabled = !sel.length; }
    g.querySelectorAll('[data-aoa-weight-box]').forEach(function (b) { b.checked = sel.indexOf(b.value) !== -1; });
    var desc = g.querySelector('[data-aoa-weight-desc]');
    if (desc) desc.innerHTML = sel.map(function (w) {
      var b = g.querySelector('[data-aoa-weight-box][value="' + w + '"]');
      return b ? '<span><b>' + w + ' ' + b.dataset.name + '</b> · ' + b.dataset.exp + '</span>' : '';
    }).join('');
    if (state.map) {
      var hidden = hiddenSet(), avail = {};
      state.map.forEach(function (it) { if (it.w && hidden.indexOf(it.h) === -1) avail[it.w] = true; });
      var n = 0;
      g.querySelectorAll('[data-aoa-weight-box]').forEach(function (b) {
        var ok = !!avail[b.value]; if (ok) n++;
        b.disabled = !ok && !b.checked;
        var l = b.nextElementSibling; if (l) l.classList.toggle('facet-checkbox--disabled', b.disabled);
      });
      // Con un solo gramaje (o ninguno) en la colección el grupo no ayuda a decidir: no se muestra
      g.hidden = n < 2 && !sel.length;
    }
  }

  function applyGrid() {
    var grid = document.getElementById('product-grid'); if (!grid) return;
    var cards = grid.querySelectorAll('.column:not(.promotion-column)');
    if (!state.sel.length || !state.map) {
      cards.forEach(function (c) { c.classList.remove('aoa-weight-out'); c.hidden = false; });
      return;
    }
    var w = {}; state.map.forEach(function (it) { w[it.h] = it.w; });
    cards.forEach(function (c) {
      var out = state.sel.indexOf(w[handleOf(c)] || '') === -1;
      c.classList.toggle('aoa-weight-out', out); c.hidden = out;
    });
  }

  function syncChips() {
    var sel = state.sel, q = sel.length ? 'weight=' + sel.join(',') : '';
    // Los chips del servidor (quitar un color, una talla…) no conocen weight: se les añade para no perderlo
    document.querySelectorAll('facet-remove.active-facets a[href], .facets__active a[href], .thb-active-filters a[href]').forEach(function (a) {
      if (a.hasAttribute('data-aoa-weight-chip') || a.classList.contains('active-facets__button-remove') || a.getAttribute('href') === '#') return;
      var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.delete('weight');
      if (sel.length) u.searchParams.set('weight', sel.join(','));
      a.setAttribute('href', u.pathname + u.search);
    });
    document.querySelectorAll('[data-aoa-weight-chip]').forEach(function (a) { a.remove(); });
    if (!sel.length) return;
    var bar = document.querySelector('facet-remove.active-facets, .facets__active, .thb-active-filters');
    if (!bar) return;
    var clear = bar.querySelector('.active-facets__button-remove, a[class*="clear"]');
    sel.forEach(function (wt) {
      var b = document.querySelector('[data-aoa-weight-box][value="' + wt + '"]');
      var a = document.createElement('a');
      a.href = '#'; a.setAttribute('data-aoa-weight-chip', wt);
      // Siempre la clase base del chip (copiarla de otro enlace traía «Clear all» o «aoa-family-chip»)
      a.className = 'active-facets__button';
      var label = (document.querySelector('[data-aoa-weight] .thb-filter-title') || {}).textContent || 'Weight';
      a.innerHTML = '<b class="aoa-chip-label">' + label.trim() + ':</b> ' + wt + ' ' + (b ? b.dataset.name : '') +
        '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></span>';
      a.setAttribute('aria-label', 'Remove filter: ' + wt + ' ' + (b ? b.dataset.name : ''));
      bar.insertBefore(a, clear && clear.parentNode === bar ? clear : null);
    });
  }

  function render() {
    state.sel = selected();
    syncDrawer(); syncChips();
    load().then(function (items) {
      if (!items) return;
      state.map = items;
      var hidden = hiddenSet();
      state.count = state.sel.length ? items.filter(function (it) { return hidden.indexOf(it.h) === -1 && state.sel.indexOf(it.w) !== -1; }).length : null;
      syncDrawer(); applyGrid(); setCountText(state.count);
      document.dispatchEvent(new CustomEvent('aoa-weight:change', { detail: { count: state.count } }));
    });
  }

  function go(sel) {
    var p = new URLSearchParams(location.search); p.delete('weight'); p.delete('page');
    if (sel.length) p.set('weight', sel.join(','));
    var qs = p.toString();
    history.pushState({ searchParams: qs }, '', location.pathname + (qs ? '?' + qs : ''));
    render();
  }

  // Elegir un gramaje: no hace falta pedir la grilla al servidor (el gramaje no cambia lo que Shopify devuelve).
  // facets.js escucha «input» en el formulario y lo enviaría: se corta aquí, antes de que llegue.
  document.addEventListener('input', function (e) {
    if (e.target.closest && e.target.closest('[data-aoa-weight-box]')) e.stopPropagation();
  }, true);
  document.addEventListener('change', function (e) {
    var b = e.target.closest && e.target.closest('[data-aoa-weight-box]'); if (!b) return;
    e.stopPropagation();
    var sel = selected().filter(function (x) { return x !== b.value; });
    if (b.checked) sel.push(b.value);
    sel.sort();
    go(sel);
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-aoa-weight-chip]'); if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    go(selected().filter(function (x) { return x !== a.getAttribute('data-aoa-weight-chip'); }));
  }, true);
  // facets.js vuelve a pintar cajón, grilla y conteo con cada filtro; la carga infinita añade tarjetas
  var pending = false;
  // Cambios que hace este mismo script (descripción, chips): no deben volver a disparar render()
  function ours(m) {
    if (m.target.closest && m.target.closest('[data-aoa-weight-desc]')) return true;
    var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes)).filter(function (n) { return n.nodeType === 1; });
    return nodes.length > 0 && nodes.every(function (n) { return n.matches && (n.matches('[data-aoa-weight-chip]') || (n.closest && n.closest('[data-aoa-weight-desc]'))); });
  }
  function soon() { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; render(); }); }
  document.addEventListener('DOMContentLoaded', function () {
    render();
    var root = document.getElementById('ProductGridContainer'), drawer = document.getElementById('Facet-Drawer');
    if ('MutationObserver' in window) {
      if (root) new MutationObserver(function (ms) {
        ms = ms.filter(function (m) { return !ours(m); }); if (!ms.length) return;
        // facets.js cambió toda la grilla: hay que volver a leer; si no, son tarjetas nuevas de la carga infinita
        if (ms.some(function (m) { return m.target.id === 'ProductGridContainer'; })) soon();
        else if (state.map && state.sel.length) applyGrid();
      }).observe(root, { childList: true, subtree: true });
      if (drawer) new MutationObserver(function (ms) {
        if (ms.some(function (m) { return !ours(m) && [].some.call(m.addedNodes, function (n) { return n.nodeType === 1; }); })) soon();
      }).observe(drawer, { childList: true, subtree: true });
    }
  });
  window.addEventListener('popstate', function () { setTimeout(render, 0); });
})();
